<template>
  <div
    v-if="hasStats"
    class="outreach-contact-social-stats"
  >
    <div
      v-for="stat in stats"
      :key="stat.text"
      class="outreach-contact-social-stats-row"
    >
      <div class="outreach-contact-social-stats-row__title">
        <OutreachContactStatLabel
          :contact="contact"
          suffix=":"
          :type="stat.id"
        />
      </div>

      <OutreachContactStat
        :contact="contact"
        :type="stat.id"
      />
    </div>
  </div>
</template>

<script setup>
import OutreachContactStat from "shared/components/Outreach/OutreachContact/OutreachContactStat.vue";
import OutreachContactStatLabel from "shared/components/Outreach/OutreachContact/OutreachContactStatLabel.vue";
import { useOutreachContactSocialStats } from "shared/composables/useOutreachContactSocialStats";

const props = defineProps({
  contact: {
    type: Object,
    required: true,
  },
});

const { stats, hasStats } = useOutreachContactSocialStats(props);
</script>

<style lang="scss" scoped>
.outreach-contact-social-stats {
  display: flex;
  flex-direction: column;
  gap: var(--s-spacing-lg);

  &-row {
    display: flex;
    align-items: center;
    gap: var(--s-spacing-md);
    font-size: var(--s-font-size-md);
    line-height: 150%;

    &__title {
      font-weight: 500;
      color: var(--s-color-denim-7);
      text-decoration: dotted underline;
    }

    &__no-data {
      .base-outreach-contact-stat {
        padding: 2.5px 8px;
        background: rgb(0 0 0 / 8%);
        border-radius: 16px;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.16px;
        color: var(--s-color-denim-9);

        &:hover {
          color: unset;
        }
      }

      .q-icon {
        color: var(--s-color-denim-5);
      }
    }
  }
}
</style>
